module.exports = __webpack_public_path__ + "static/media/comment-minus.aed36ea0.svg";